import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config"; // i18n initialisation — must be early
import { captureUtm } from "./lib/utm";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    // Errors only — no performance tracing, no session replay
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

captureUtm(); // capture UTM params before React mounts so they're available for checkout

createRoot(document.getElementById("root")!).render(
  SENTRY_DSN ? (
    <Sentry.ErrorBoundary fallback={<div />}>
      <App />
    </Sentry.ErrorBoundary>
  ) : (
    <App />
  )
);
